// HEADER-DOCS-012: shared role helpers for the Documents tab.
// Mirrors the backend rule in cam-documents.service.ts (isOwnStudentDoc):
// a student owns a document only when created_by_id = self AND created_by_role = 'student'.
// The server enforces everything; these helpers only hide affordances for cleaner UX.

import { DocumentDto } from '../../../../services/camMirrorService';

export type ViewerRole = 'counselor' | 'student' | 'parent';

export function isOwnStudentDoc(doc: DocumentDto, currentUserId: number | null): boolean {
  return currentUserId != null && doc.createdBy.id === currentUserId && doc.createdBy.role === 'student';
}

// Edit + delete share the same rule in v1: counselor any, student own, parent none.
export function canModifyDoc(
  doc: DocumentDto,
  viewerRole: ViewerRole,
  currentUserId: number | null
): boolean {
  if (viewerRole === 'counselor') return true;
  if (viewerRole === 'student') return isOwnStudentDoc(doc, currentUserId);
  return false;
}
